import adminInfoReducer from "./features/admin";
import authReducer from "./features/authSlice";
import breadcrumbReducer from "./features/breadCrumb";
import { configureStore } from "@reduxjs/toolkit";
import globalInfoReducer from "./features/global";

const store = configureStore({
    reducer: {
        adminInfo: adminInfoReducer,
        auth: authReducer,
        globalInfo: globalInfoReducer,
        breadcrumb: breadcrumbReducer
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;